import React, { useState, useEffect } from 'react';
import {
  Tabs,
  Form,
  DatePicker,
  Select,
  Table,
  Checkbox,
  message,
  Col,
  Row,
  Input
} from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
// , EyeOutlined
import moment from 'moment';
import CustomModal from '@/common/CustomModal';
import CustomButton from '@/common/CustomButton';
import FormItem from '@/common/FormItem';
import './AddDelegationModal.css';
import { useDispatch } from 'react-redux';
import LocalStorage from 'utilities/localStorage';
import { updateDelegationId } from '../../../redux/slice';
// import { updateDelegationId } from '@/pages/settings/redux/slice';

const { TabPane } = Tabs;
const { Option } = Select;

const EditDelegationModal = ({
  isEditModalVisible = false,
  onCancel,
  setIsEditModalOpen,
  onDelegate,
  handleGetActivity,
  editDelegationDetails,
  allApprovers,
  allPendingEnvelopes
  // delegationData = null
}) => {
  const [activeTab, setActiveTab] = useState('future');
  const [futureForm] = Form.useForm();
  const [stockForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedEnvelopes, setSelectedEnvelopes] = useState([]);

  const dispatch = useDispatch();
  const user = LocalStorage.getItem('gnfa_user');
  const approvers = allApprovers;

  console.log('allPendingEnvelopes', allPendingEnvelopes);
  console.log('Selected IDs', selectedEnvelopes);

  // const envelopes = allPendingEnvelopes || [];
  const envelopes =
    allPendingEnvelopes?.map((e) => ({
      id: Number(e.id),
      title: e.title
    })) || [];

  // Deduplication function based on envelope ID
  const deduplicateEnvelopes = (envelopes) => {
    return [
      ...new Map(
        envelopes.map((item) => [item.id, item]) // Ensures unique envelopes based on ID
      ).values()
    ];
  };
  // 🔁 Format the incoming payload to match the form
  const formatDelegationData = (data) => {
    if (!data) return null;
    return {
      id: data.id,
      type: data.type,
      delegation_start: data.fut_del_start
        ? moment(data.fut_del_start)
        : undefined,
      delegation_end: data.fut_del_end ? moment(data.fut_del_end) : undefined,
      delegator_id: data.delegator_id,
      delegate_id: data.delegate_id,
      // env_ids: data.envelope_approvers?.map((e) => e.envelope_id) || []
      env_ids:
        data.envelope_approvers?.map((e) => ({
          id: e.envelope?.id,
          // id: Number(e.envelope?.id),
          title: e.envelope?.title
        })) || []
      // env_ids: data.envelope_approvers?.map((e) => e.envelope_id) || [],
      // env_ids:
      //   data.envelope_approvers?.map((e) => ({
      //     id: e.envelope?.id,
      //     title: e.envelope?.title
      //   })) || []
    };
  };

  useEffect(() => {
    if (editDelegationDetails && isEditModalVisible) {
      const formatted = formatDelegationData(editDelegationDetails);
      setActiveTab(formatted.type || 'future');

      if (formatted.type === 'future') {
        futureForm.setFieldsValue({
          delegation_start: formatted.delegation_start,
          delegation_end: formatted.delegation_end,
          delegator_id: formatted.delegator_id,
          delegate_id: formatted.delegate_id
        });
      } else if (formatted.type === 'stock') {
        stockForm.setFieldsValue({
          delegator_id: formatted.delegator_id,
          delegate_id: formatted.delegate_id
        });

        // setSelectedEnvelopes(formatted.env_ids);
        // const uniqueEnvelopes = deduplicateEnvelopes(formatted.env_ids);
        // setSelectedEnvelopes(uniqueEnvelopes);
        const selectedEnvelopeIds = formatted.env_ids.map((env) =>
          Number(env.id)
        );
        setSelectedEnvelopes(selectedEnvelopeIds);
        stockForm.setFieldsValue({ env_ids: selectedEnvelopeIds });
      }
    }
  }, [editDelegationDetails, isEditModalVisible, futureForm, stockForm]);

  const handleTabChange = (key) => setActiveTab(key);

  const handleModalClose = () => {
    futureForm.resetFields();
    stockForm.resetFields();
    setSelectedEnvelopes([]);
    setIsEditModalOpen?.(false);
    onCancel?.();
  };

  const handleFutureSubmit = async (values) => {
    setLoading(true);
    try {
      const updatedDelegationData = {
        id: editDelegationDetails.id,
        type: 'future',
        delegation_start: values.delegation_start.format('YYYY-MM-DD HH:mm:ss'),
        delegation_end: values.delegation_end.format('YYYY-MM-DD HH:mm:ss'),
        delegator_id: values.delegator_id,
        delegate_id: values.delegate_id
      };

      const response = await dispatch(
        updateDelegationId(updatedDelegationData)
      );
      if (response.payload.success) {
        message.success('Delegation updated successfully');
        onDelegate?.('future', updatedDelegationData);
        handleGetActivity?.();
        handleModalClose();
      } else {
        message.error(response.payload.message);
      }
    } catch (error) {
      message.error('Failed to update delegation');
    } finally {
      setLoading(false);
    }
  };

  const handleStockSubmit = async (values) => {
    if (selectedEnvelopes.length === 0) {
      message.error('Please select at least one envelope');
      return;
    }

    setLoading(true);
    try {
      const updatedDelegationData = {
        id: editDelegationDetails.id,
        type: 'stock',
        delegator_id: values.delegator_id,
        delegate_id: values.delegate_id,
        env_ids: selectedEnvelopes
      };

      const response = await dispatch(
        updateDelegationId(updatedDelegationData)
      );
      if (response.payload.success) {
        message.success('Delegation updated successfully');
        onDelegate?.('stock', updatedDelegationData);
        handleGetActivity?.();
        handleModalClose();
      } else {
        message.error(response.payload.message);
      }
    } catch (error) {
      message.error('Failed to update delegation');
    } finally {
      setLoading(false);
    }
  };

  console.log('selectedEnvelopes123', selectedEnvelopes);
  const isAllSelected = selectedEnvelopes.length === envelopes.length;
  console.log('isAllSelected123', isAllSelected);
  const isIndeterminate =
    selectedEnvelopes.length > 0 && selectedEnvelopes.length < envelopes.length;
  console.log('isIndeterminate123', isIndeterminate);
  // const envelopeColumns = [
  //   {
  //     title: '',
  //     dataIndex: 'id',
  //     width: 50,
  //     render: (id) => (
  //       <Checkbox
  //         checked={selectedEnvelopes.includes(id)}
  //         onChange={(e) => {
  //           const updated = e.target.checked
  //             ? [...selectedEnvelopes, id]
  //             : selectedEnvelopes.filter((item) => item !== id);
  //           setSelectedEnvelopes(updated);
  //           stockForm.setFieldsValue({ env_ids: updated });
  //         }}
  //       />
  //     )
  //   },
  //   {
  //     title: 'Envelope ID',
  //     dataIndex: 'id',
  //     render: (id) => `#${id}`
  //   },
  //   {
  //     title: 'Name',
  //     // dataIndex: 'name'
  //     dataIndex: 'title'
  //   }
  // ];
  const envelopeColumns = [
    {
      title: (
        <Checkbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={(e) => {
            const allIds = e.target.checked ? envelopes.map((e) => e.id) : [];
            setSelectedEnvelopes(allIds);
            stockForm.setFieldsValue({ env_ids: allIds });
          }}
        />
      ),
      dataIndex: 'id',
      width: 50,
      render: (id) => (
        <Checkbox
          checked={selectedEnvelopes.includes(id)}
          onChange={(e) => {
            const updated = e.target.checked
              ? [...selectedEnvelopes, id]
              : selectedEnvelopes.filter((item) => item !== id);
            setSelectedEnvelopes(updated);
            stockForm.setFieldsValue({ env_ids: updated });
          }}
        />
      )
    },
    {
      title: 'Envelope ID',
      dataIndex: 'id',
      render: (id) => `#${id}`
    },
    {
      title: 'Name',
      dataIndex: 'title'
    }
  ];

  const renderFutureTab = () => (
    <Form form={futureForm} onFinish={handleFutureSubmit} layout="vertical">
      <Row gutter={16}>
        <Col span={12}>
          <FormItem
            label="Start Date"
            name="delegation_start"
            rules={[{ required: true, message: 'Please select start date' }]}
          >
            <DatePicker
              format="YYYY-MM-DD"
              disabledDate={(current) =>
                current && current < moment().startOf('day')
              }
              suffixIcon={<CalendarOutlined />}
              style={{ width: '100%' }}
            />
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            label="End Date"
            name="delegation_end"
            rules={[
              { required: true, message: 'Please select end date' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startDate = getFieldValue('delegation_start');
                  if (!startDate || !value || value.isAfter(startDate)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('End date must be after start date')
                  );
                }
              })
            ]}
          >
            <DatePicker
              format="YYYY-MM-DD"
              suffixIcon={<CalendarOutlined />}
              style={{ width: '100%' }}
            />
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign From Approver"
            name="delegator_id"
            rules={[{ required: true }]}
          >
            {user?.user_details.role === 'user' ? (
              <Select disabled value={user?.user_details?.id}>
                <Option value={user?.user_details?.id}>
                  {user?.user_details?.display_name}
                </Option>
              </Select>
            ) : (
              <Select showSearch placeholder="Select approver">
                {approvers.map((approver) => (
                  <Option key={approver.id} value={approver.id}>
                    {`${approver.display_name} - (${approver.email})`}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign To Approver"
            name="delegate_id"
            rules={[{ required: true }]}
          >
            <Select showSearch placeholder="Select approver">
              {approvers.map((approver) => (
                <Option key={approver.id} value={approver.id}>
                  {`${approver.display_name} - (${approver.email})`}
                </Option>
              ))}
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
  );

  const renderStockTab = () => (
    <Form form={stockForm} onFinish={handleStockSubmit} layout="vertical">
      <FormItem name="env_ids" hidden>
        <Input />
      </FormItem>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign From Approver"
            name="delegator_id"
            rules={[{ required: true }]}
          >
            {user?.user_details.role === 'user' ? (
              <Select disabled value={user?.user_details?.id}>
                <Option value={user?.user_details?.id}>
                  {user?.user_details?.display_name}
                </Option>
              </Select>
            ) : (
              <Select showSearch placeholder="Select approver">
                {approvers.map((approver) => (
                  <Option key={approver.id} value={approver.id}>
                    {`${approver.display_name} - (${approver.email})`}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign To Approver"
            name="delegate_id"
            rules={[{ required: true }]}
          >
            <Select showSearch placeholder="Select approver">
              {approvers.map((approver) => (
                <Option key={approver.id} value={approver.id}>
                  {`${approver.display_name} - (${approver.email})`}
                </Option>
              ))}
            </Select>
          </FormItem>
        </Col>
      </Row>

      <div className="envelope-section">
        <div className="envelope-header">
          <h4>Select Envelopes</h4>
          <span className="selection-count">
            {selectedEnvelopes.length} of {envelopes.length} selected
            {/* {new Set(selectedEnvelopes.map((e) => e.id)).size} of{' '}
            {envelopes.length} selected */}
          </span>
        </div>

        {/* <div className="select-all-wrapper">
          <Checkbox
            checked={isAllSelected}
            indeterminate={isIndeterminate}
            onChange={(e) => {
              const allIds = e.target.checked ? envelopes.map((e) => e.id) : [];
              setSelectedEnvelopes(allIds);
              stockForm.setFieldsValue({ env_ids: allIds });
            }}
          >
            Select All
          </Checkbox>
        </div> */}

        <Table
          // dataSource={envelopes}
          dataSource={deduplicateEnvelopes(envelopes)}
          columns={envelopeColumns}
          pagination={false}
          size="small"
          className="envelope-table"
          rowClassName="envelope-row"
        />
      </div>
    </Form>
  );

  const getFooterButtons = () => {
    const currentForm = activeTab === 'future' ? futureForm : stockForm;
    const isStockInvalid =
      activeTab === 'stock' && selectedEnvelopes.length === 0;

    return (
      <Form
        form={currentForm}
        onFinish={
          activeTab === 'future' ? handleFutureSubmit : handleStockSubmit
        }
        layout="vertical"
        className="ant-form ant-form-vertical"
      >
        <Row>
          <Col className="text-left" span={12}>
            <CustomButton onClick={handleModalClose}>Cancel</CustomButton>
          </Col>
          <Col className="text-right" span={12}>
            <CustomButton
              type="primary"
              loading={loading}
              disabled={isStockInvalid}
              onClick={() => currentForm.submit()}
            >
              {loading ? 'Updating...' : 'Update'}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    );
  };

  return (
    <CustomModal
      footer={getFooterButtons()}
      onCancel={handleModalClose}
      visible={isEditModalVisible}
      title="Edit Delegation"
      width={600}
      className="delegation-modal"
    >
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        className="delegation-tabs"
      >
        <TabPane tab="Future" key="future">
          {renderFutureTab()}
        </TabPane>
        <TabPane tab="Stock" key="stock">
          {renderStockTab()}
        </TabPane>
      </Tabs>
    </CustomModal>
  );
};

export default EditDelegationModal;
